import { useNavigate, useParams } from "react-router-dom";
import { intl } from "LocaleWrapper";
import { useQuery } from "@apollo/client";

import { FormGroup, Card, PageHeader, Button } from "@cofano/cck";
import { Grid2 as Grid } from "@mui/material";

import Helmet from "components/helmet/Helmet";
import useRequest from "components/hooks/useRequest";

import { Language, usePermission } from "imports/Utils";

import { WaterLevelLink } from "utils/LinkUtils";

import WaterLevelStaffelItemsTable from "./components/tables/WaterLevelStaffelItemsTable";
import { StaffelTabs } from "./utils/StaffelUtils";

import { GetStaffelDocument } from "__generated__/view/staffels/graphql/staffel.queries.generated";

const WaterLevelStaffelDetails = () => {

	const [ measuringPoints ] = useRequest<{ id: number, name: string }[]>({ defaultResponse: [], url: "waterlevels/measuring-points" });

	const navigate = useNavigate();
	const { id } = useParams();

	const { isAdmin, isMasterdata, isReadOnly } = usePermission();

	const { data, loading } = useQuery(GetStaffelDocument, {
		variables: {
			id: Number(id),
		},
	});

	return (
		<div>
			<PageHeader>
				<PageHeader.Title>
					{Language("WATERLEVEL")}
					<Helmet title={intl.formatMessage({ id: "WATERLEVEL" })} />
				</PageHeader.Title>

				<PageHeader.Actions>
					<Button onClick={() => navigate(`/view/staffels?tab=${StaffelTabs.WATER_LEVEL}`)} variant="outlined">
						{Language("STAFFELS")}
					</Button>

					{((isAdmin || isMasterdata) && !isReadOnly) && (
						<Button onClick={() => navigate(`/view/staffels/${id}/edit/waterlevel`)}>
							{Language("EDIT")}
						</Button>
					)}
				</PageHeader.Actions>
			</PageHeader>

			<Grid spacing={3} container>
				<Grid size={6}>
					<Card>
						<FormGroup label={intl.formatMessage({ id: "DESCRIPTION" })} labelPlacement="left-center" overflow="hidden">
							{data?.staffel?.description}
						</FormGroup>

						{data?.staffel?.__typename === "WaterLevelStaffel" && (
							<FormGroup label={intl.formatMessage({ id: "LOCATION" })} labelPlacement="left-center" overflow="hidden">
								<WaterLevelLink name={measuringPoints.find((m) => data?.staffel && "waterlevelMeasuringPoint" in data.staffel && m.id == data?.staffel?.waterlevelMeasuringPoint)?.name} />
							</FormGroup>
						)}

						<WaterLevelStaffelItemsTable
							content={data?.staffel?.staffelItems ?? []}
							contentLoading={loading} />
					</Card>
				</Grid>
			</Grid>
		</div>
	);
};

export default WaterLevelStaffelDetails;
